import { gql } from 'graphql-tag';

import {
  SessionInfoFragment,
} from '@/graphql/fragments';

export const UPDATE_SESSION = gql`
  ${SessionInfoFragment}

  mutation updateSession($updatedSessionData: SessionInputType!) {
    updateSession(updatedSessionData: $updatedSessionData) {
      session{
        ...SessionInfo
      }
      message
      status
    }
  }
`;
